/***
 * Model that represents Queue Notification
 */
import Backbone from 'backbone';

var Notification = Backbone.Model.extend({
    backend: 'gcapi',

    urlRoot: function() {
        return `/notification-service/notification/notification/cursor`;
    },

    idAttribute: 'notificationId',

    parse: function(resp) {
        if (resp && resp.hasOwnProperty('attributes')) {
            resp.attributes = resp.attributes.replace('-', '_');
            this.handleBadCommentAttributes(resp);
        }
        return resp;
    },

    handleBadCommentAttributes: function(resp) {
        const nameValues = resp.relativeNameValue;
        if (nameValues.device && nameValues.device.indexOf('device-name') > 0) {
            let deviceData = nameValues.device.split('|');
            nameValues.device_name = deviceData[2];
            nameValues.device = deviceData[0];
        }
    },

    sync: function(method, model, options) {
        if (method === 'update') {
            options.url = `/notification-service/notification/${this.id}/dismiss/${this.get('dismiss')}`;
        }
        Backbone.sync.call(this, method, model, options);
    }
});

export default Notification;
